import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Mail, Loader2, ArrowLeft } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/account/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-screen bg-background flex items-center justify-center px-6 py-24">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Mail className="w-12 h-12 text-primary mx-auto" />
          <h1 className="font-anton text-4xl uppercase tracking-tight mt-5 text-white">Forgot password</h1>
          <p className="text-white/60 mt-3 text-sm">Enter your email and we'll send you a reset link.</p>
        </div>

        {sent ? (
          <div data-testid="forgot-sent" className="border border-primary/30 bg-primary/5 p-6 text-center">
            <p className="text-white text-sm">
              If an account exists for <b>{email}</b>, a password reset link is on its way. Check your inbox
              (and spam) — the link expires in 30 minutes.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input
              data-testid="forgot-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="w-full bg-transparent border border-white/20 focus:border-primary outline-none p-3.5 text-white placeholder:text-white/30"
            />
            {error && <p className="text-sm text-red-400">{error}</p>}
            <button
              type="submit"
              data-testid="forgot-submit-button"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-primary text-black hover:bg-white disabled:opacity-40 px-8 py-4 font-bold uppercase tracking-[0.2em] text-sm transition-colors active:scale-95"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />} Send reset link
            </button>
          </form>
        )}

        <p className="text-center mt-8">
          <Link to="/login" className="inline-flex items-center gap-1.5 text-white/50 hover:text-white text-xs uppercase tracking-widest">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to login
          </Link>
        </p>
      </div>
    </div>
  );
}
